import { Link } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-base p-4">
      <div className="text-center max-w-md">
        <h1 className="text-9xl font-bold text-primary-500 mb-4">404</h1>
        <h2 className="text-3xl font-bold text-text-primary mb-4">Page Not Found</h2>
        <p className="text-text-secondary mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-4">
          <button onClick={() => window.history.back()} className="btn btn-ghost">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </button>
          <Link to="/" className="btn btn-primary">
            <Home className="w-4 h-4 mr-2" />
            Home
          </Link>
        </div>
      </div>
    </div>
  )
}
